import { Document, FileAttachment, FilePdf } from '@/assets/icons'
import { MimeType } from '@/constants/constants-mime-types'
import { isEmailFile } from '@/user_files/utils/group-extracted-files'

type UserFileTypeIconProps = {
  detectedContentType: string | null | undefined
  detectedExtension?: string | null
  originalFilename?: string | null
  /** When true, email containers (.eml / .msg) use the file-attachment icon instead of the default document icon. */
  hasExtractedAttachments?: boolean
  className: string
}

function isPdfContentType(detectedContentType: string | null | undefined): boolean {
  return detectedContentType?.split(';')[0]?.trim().toLowerCase() === MimeType.PDF
}

export function UserFileTypeIcon({
  detectedContentType,
  detectedExtension,
  originalFilename,
  hasExtractedAttachments = false,
  className,
}: UserFileTypeIconProps) {
  const isEmail = isEmailFile({
    detected_content_type: detectedContentType ?? null,
    detected_extension: detectedExtension ?? null,
    original_filename: originalFilename ?? '',
  })
  if (isEmail && hasExtractedAttachments) {
    return <FileAttachment className={className} aria-hidden />
  }
  const Icon = isPdfContentType(detectedContentType) ? FilePdf : Document
  return <Icon className={className} aria-hidden />
}
